import {
  Box,
  Checkbox,
  FormControlLabel,
  FormGroup,
  IconButton,
  List,
  MenuItem,
  TextField,
  Typography,
  Select,
} from "@mui/material";
import HashtagItemComponent from "../hashtag/HashtagItemComponent";
import AddCircleIcon from "@mui/icons-material/AddCircle";

const FormComponent: React.FC<{
  name;
  onChangeName;
  nameError;
  hashtags;
  handleAddHashtag;
  hashtagText;
  onChangeHashtagText;
  inTitleContent;
  onChangeInTitleContent;
  hashtagsError;
  hashtagsTextError;
  handleRemoveHashtag;
  displayTypes;
  selectedDisplayType;
  onSelectDisplayType;
}> = ({
  name,
  onChangeName,
  nameError,
  hashtags,
  handleAddHashtag,
  hashtagText,
  onChangeHashtagText,
  inTitleContent,
  onChangeInTitleContent,
  hashtagsError,
  hashtagsTextError,
  handleRemoveHashtag,
  displayTypes,
  selectedDisplayType,
  onSelectDisplayType,
}) => {
  return (
    <>
      <TextField
        fullWidth
        label="Name"
        variant="outlined"
        value={name}
        onChange={onChangeName}
        sx={{
          "& .MuiInputLabel-root": { color: "#b0b0b0" }, // Label color
          "& .MuiOutlinedInput-root": {
            "& fieldset": { borderColor: "#444" },
            "&:hover fieldset": { borderColor: "#888" },
            "&.Mui-focused fieldset": { borderColor: "#1976d2" }, // Focused state
          },
          input: { color: "#ffffff" }, // Input text color
          marginBottom: 3,
          marginTop: 4,
        }}
        error={nameError.trim() ? true : false}
        helperText={nameError.trim() ? nameError : ""}
      />
      <Select
        fullWidth
        displayEmpty
        renderValue={(value: any) => {
          if (!value) {
            return <Typography color="gray">Display type</Typography>;
          }
          return displayTypes.find((x) => x.id === value).type;
        }}
        value={selectedDisplayType ? selectedDisplayType : null}
        sx={{
          color: "#ffffff",
          borderRadius: "4px",
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "#444",
          },
          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: "#888",
          },
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: "#1976d2",
          },
          "& .MuiSelect-icon": {
            color: "#ffffff",
          },
          marginTop: 1,
          marginBottom: 3,
        }}
        onChange={onSelectDisplayType}
      >
        {displayTypes.map((displayType, index) => {
          return (
            <MenuItem key={index} value={displayType.id}>
              {displayType.type}
            </MenuItem>
          );
        })}
      </Select>
      <Typography
        variant="subtitle1"
        sx={{ color: "#ffffff", marginBottom: 1 }}
      >
        Hashtags
      </Typography>
      <List sx={{ width: "100%", border: "1px" }}>
        {hashtags.map((hashtag, index) => (
          <HashtagItemComponent
            hashtag={hashtag}
            removeHashtagFunc={() => handleRemoveHashtag(index)}
          />
        ))}
      </List>

      <Box sx={{ display: "flex", marginBottom: 2 }}>
        <IconButton onClick={handleAddHashtag} color="info">
          <AddCircleIcon />
        </IconButton>
        <TextField
          label="Hashtag"
          variant="outlined"
          value={hashtagText}
          onChange={onChangeHashtagText}
          sx={{
            "& .MuiInputLabel-root": { color: "#b0b0b0" }, // Label color
            "& .MuiOutlinedInput-root": {
              "& fieldset": { borderColor: "#444" },
              "&:hover fieldset": { borderColor: "#888" },
              "&.Mui-focused fieldset": { borderColor: "#1976d2" }, // Focused state
            },
            flex: 1,
            input: { color: "#ffffff" }, // Input text color
            marginLeft: 2,
          }}
          error={hashtagsTextError.trim() ? true : false}
          helperText={hashtagsTextError.trim() ? hashtagsTextError : ""}
        />
        <FormGroup style={{ display: "contents" }}>
          <FormControlLabel
            control={
              <Checkbox
                sx={{ color: "#ffffff" }}
                onChange={onChangeInTitleContent}
                checked={inTitleContent}
              />
            }
            label="In Title Content"
            sx={{ marginLeft: 2, color: "#ffffff", marginTop: "23px" }}
          />
        </FormGroup>
      </Box>
      {hashtagsError.trim() ? (
        <p
          style={{
            color: "red",
            fontSize: "0.75rem",
            textAlign: "left",
          }}
        >
          *{hashtagsError}
        </p>
      ) : null}
    </>
  );
};

export default FormComponent;
